// src/utils/authFetch.js
import { pulisciAlLogout } from '../offline/db.js';
import { eErroreDiRete } from './rete.js';
export async function authFetch(url, options = {}) {
  let token = localStorage.getItem('token');

  const headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
  };

  let res = await fetch(url, { ...options, headers });

  if (res.status === 401) {
    let errorData = {};
    try {
      errorData = await res.clone().json();
    } catch (_) {}

    if (errorData.code === 'TOKEN_EXPIRED') {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        logoutAndRedirect();
        return null;
      }

      try {
        const refreshRes = await fetch('/api/refresh-token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ refreshToken }),
        });

        if (!refreshRes.ok) {
          logoutAndRedirect();
          return null;
        }

        const refreshData = await refreshRes.json();
        const newToken = refreshData.token;

        if (!newToken) {
          logoutAndRedirect();
          return null;
        }

        localStorage.setItem('token', newToken);

        const retryHeaders = {
          ...options.headers,
          Authorization: `Bearer ${newToken}`,
        };

        return await fetch(url, { ...options, headers: retryHeaders });
      } catch (err) {
        console.error('Errore nel refresh token:', err);
        // se e' caduta la rete a meta' rinnovo, il token non e' invalido:
        // si riprova alla prossima chiamata
        if (!eErroreDiRete(err)) logoutAndRedirect();
        return null;
      }
    }

    // Per altri 401 non fare logout immediato: restituisci la risposta
    return res;
  }

  return res;
}

function logoutAndRedirect() {
  // i dati scaricati vanno via, la coda di invio no: vedi pulisciAlLogout
  pulisciAlLogout().catch(() => {});

  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('role');
  localStorage.removeItem('profilePicture');
  localStorage.removeItem('mustChangePassword');
  window.location.href = '/login';
}